import {
    FETCH_TECHNICIAN_PARTNER_LIST,
    RESET_TECHNICIAN_PARTNER_LIST,
  } from "../../constants/action.constants";
  
  const initialState = {
    list: [],
    selectList: [],
    others: {},
  };
  
  const technicianPartnerListReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_TECHNICIAN_PARTNER_LIST:
        return {
          list: action.payload,
          others: action.others,
          // selectList: action.payload.filter((item) => item.is_active),
        };
      case RESET_TECHNICIAN_PARTNER_LIST:
        return initialState;
      default:
        return state;
    }
  };
  
  export default technicianPartnerListReducer;
  